import upload from "./upload";
import dialog from "./dialog";
import list from "./list";
import echarts from './echarts';
import qqmap from './qqmap/index';
import drawer from './drawer';
import uploadPic from './uploadpic'
import timeIntervalPicker from './timeintervalpicker'
import typeTab from './typetab'
import statusTab from './statustab'
import pcaSelector from './PcaSelector'

export default {
  install(Vue, options) {
    Vue.use(upload);
    Vue.use(dialog);
    Vue.use(list);
    Vue.use(echarts);
    Vue.use(qqmap);
    Vue.use(drawer);
    Vue.use(uploadPic);
    Vue.use(timeIntervalPicker);
    Vue.use(typeTab);
    Vue.use(statusTab);
	Vue.use(pcaSelector);
  }
};
